export default __webpack_public_path__ + "static/media/Thumb_Glasses_02.0d159048.png";